import { render, staticRenderFns } from "./UserBill.vue?vue&type=template&id=7c350185&scoped=true&"
import script from "./UserBill.vue?vue&type=script&lang=js&"
export * from "./UserBill.vue?vue&type=script&lang=js&"
import style0 from "./UserBill.vue?vue&type=style&index=0&id=7c350185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c350185",
  null
  
)

export default component.exports